import React from "react";
import { Link } from "react-router-dom";

import "./LandingPage.css";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <div className="splash">
        <h3 className="splash-h3">Find The Best Places To</h3>
        <h1 className="splash-h1">Get Away</h1>
        <h3 className="splash-h3">For Your Best Times</h3>
        <Link to="/places" className="splash-button">
          Explore Now
        </Link>
      </div>
    </div>
  );
};

export default LandingPage;
